export const QUALITY_POLL_MS = 4_000;
export const MAX_QUALITY_ARRIVALS = 64;

export type ArrivalLog = {
  mark: string;
  arrivals: number[];
};

export function emptyArrivalLog(): ArrivalLog {
  return { mark: "", arrivals: [] };
}

export function noteQualityArrival(
  log: ArrivalLog,
  samples: readonly { sampledAt: string }[],
  nowMs: number,
): ArrivalLog {
  if (samples.length === 0) return log;
  const mark = `${samples.length}:${samples[samples.length - 1]?.sampledAt ?? ""}`;
  if (mark === log.mark) return log;
  return { mark, arrivals: [...log.arrivals, nowMs].slice(-MAX_QUALITY_ARRIVALS) };
}
